<template>
	<div
		v-if="message.messageType === 'StatusMelding'"
		class="flex flex-col gap-1"
	>
		<div>
			<span>Status gewijzigd: </span>
			<span class="text-[var(--text-primary)] font-semibold">
				{{ statusValue }}
			</span>
			<span> (SX{{ statusKey }}) </span>
		</div>
		<LoanApplicationKeyValue
			v-if="message.properties['submissionMoment']"
			class="pl-3"
			:entries="submissionMomentEntries"
		/>
		<ul v-if="message.properties['text']" class="pl-3">
			<span v-for="line in message.properties['text']" :key="line.text">
				{{ line.text }}
			</span>
		</ul>
		<details
			v-if="message.properties['passageData']"
			class="pl-3 flex flex-col"
		>
			<summary class="cursor-pointer text-blue-500 hover:underline self-start">
				Bekijk de lening
			</summary>
			<LoanApplicationPassageData class="pl-3" :message="message" />
		</details>
	</div>
</template>

<script setup lang="ts">
import { splitHdnValue, useSplitHdnValue } from "@/helpers/hdnHelpers";
import type { LoanApplicationStatusMessage } from "@/models/LoanApplicationStatusMessage";
import { computed } from "vue";

const props = defineProps<{
	message: LoanApplicationStatusMessage;
}>();

const [statusKey, statusValue] = useSplitHdnValue(
	() => props.message.properties["status"],
);

const submissionMomentEntries = computed(() => {
	if (!props.message.properties["submissionMoment"]) return {};
	const [, submissionMoment] = splitHdnValue(
		props.message.properties["submissionMoment"],
	);

	return {
		"Stukken aanleveren: ": submissionMoment.toLowerCase(),
	};
});
</script>
